const color = {
  bg: {
    default: "var(--color-fill-default)",
    fill: {
      primary: "var(--color-fill-primary)",
      primaryHover: "var(--color-fill-primary-hover)",
      primaryActive: "var(--color-fill-primary-active)",
      secondaryHover: "var(--color-fill-secondary-hover)",
      secondaryActive: "var(--color-fill-secondary-active)",
      solid: "var(--color-fill-solid)",
      solidHover: "var(--color-fill-solid-hover)",
      solidActive: "var(--color-fill-solid-active)",
    },
    brand: {
      fill: "var(--color-fill-brand)",
      hover: "var(--color-fill-brand-hover)",
      active: "var(--color-fill-brand-active)",
      selected: "var(--color-fill-brand-selected)",
    },
    surface: {
      surface: "var(--color-surface)",
      active: "var(--color-surface-active)",
      secondary: "var(--color-surface-secondary)",
      primaryHover: "var(--color-surface-secondary-hover)",
      secondaryActive: "var(--color-surface-secondary-active)",
    },
  },
  border: {
    border: "var(--color-border)",
    brand: "var(--color-border-brand)",
    hover: "var(--color-border-hover)",
    active: "var(--color-border-active)",
    selected: "var(--color-border-selected)",
    secondary: "var(--color-border-secondary)",
  },
  tooltip: {
    bg: "var(--color-tooltip-bg)",
  },
  ring: {
    ring: "var(--color-ring)",
  },
  icon: {
    primary: "var(--color-icon-primary)",
    primaryHover: "var(--color-icon-primary-hover)",
    primaryActive: "var(--color-icon-primary-active)",
    secondary: "var(--color-icon-secondary)",
    secondaryHover: "var(--color-icon-secondary-hover)",
    secondaryActive: "var(--color-icon-secondary-active)",
    error: "var(--color-border-error)",
    onBgFill: "var(--color-icon-on-bg-fill)",
    brand: "var(--color-icon-brand)",
  },
  text: {
    primary: "var(--color-text-primary)",
    primaryHover: "var(--color-text-primary-hover)",
    primaryActive: "var(--color-text-primary-active)",
    secondary: "var(--color-text-secondary)",
    tertiary: "var(--color-text-tertiary)",
    success: "var(--color-text-success)",
    onBgFill: "var(--color-text-on-bg-fill)",
    error: "var(--color-text-error)",
    brand: "var(--color-text-brand)",
  },
  input: {
    bgSurface: "var(--color-input-surface-fill)",
    bgSurfaceHover: "var(--color-input-surface-hover)",
    bgSurfaceActive: "var(--color-input-surface-active)",
    borderFocus: "var(--color-input-border)",
    border: "var(--color-input-border)",
    borderHover: "var(--color-input-border-hover)",
    borderHoverActive: "var(--color-input-border-active)",
    borderError: "var(--color-input-border-error)",
  },
  transport: {
    animal: "var(--color-transport-animal)",
    bike: "var(--color-transport-bike)",
    bus: "var(--color-transport-bus)",
    busferry: "var(--color-transport-bus)",
    cablecar: "var(--color-transport-cablecar)",
    car: "var(--color-transport-car)",
    carferry: "var(--color-transport-ferry)",
    ferry: "var(--color-transport-ferry)",
    helicopter: "var(--color-transport-helicopter)",
    nightbus: "var(--color-transport-nightbus)",
    nighttrain: "var(--color-transport-nighttrain)",
    plane: "var(--color-transport-plane)",
    rideshare: "var(--color-transport-rideshare)",
    shuttle: "var(--color-transport-shuttle)",
    subway: "var(--color-transport-subway)",
    taxi: "var(--color-transport-taxi)",
    train: "var(--color-transport-train)",
    tram: "var(--color-transport-tram)",
    towncar: "var(--color-transport-towncar)",
    unknown: "var(--color-transport-walk)",
    walk: "var(--color-transport-walk)",
    multi: "var(--color-transport-multi)",
    privatetransfer: "var(--color-transport-privatetransfer)",
    // In some instances we need hex in JS.
    // ie. Google Maps polylines.
    // Only add hex values that are being used in the app here.
    hex: {
      plane: "#04c9a6",
      helicopter: "#04c9a6",
      train: "#734286",
      nighttrain: "#734286",
      tram: "#734286",
      subway: "#734286",
      cablecar: "#734286",
      bus: "#e47225",
      busferry: "#e47225",
      nightbus: "#e47225",
      taxi: "#ffad00",
      ferry: "#2ebad3",
      car: "#171717",
      carferry: "#171717",
      towncar: "#2b2b2b",
      animal: "#171717",
      walk: "#4d4d4d",
      bike: "#24b94e",
      shuttle: "#e0043b",
      rideshare: "#e0043b",
      privatetransfer: "#e0043b",
      multi: "#de007b",
      unknown: "#4d4d4d",
    },
  },
  /**
   * @deprecated Use the CSS variable variant instead.
   */
  legacy: {
    bg: {
      brand: {
        fill: "#de007b",
      },
    },
  },
  primitive: {
    product100: "var(--color-product-100)",
    product200: "var(--color-product-200)",
    product300: "var(--color-product-300)",
    product400: "var(--color-product-400)",
    product500: "var(--color-product-500)",
    product600: "var(--color-product-600)",
    product700: "var(--color-product-700)",
    product800: "var(--color-product-800)",
    product900: "var(--color-product-900)",
    product1000: "var(--color-product-1000)",
    product1100: "var(--color-product-1100)",
    product1300: "var(--color-product-1300)",
    neutral100: "var(--color-neutral-100)",
    neutral200: "var(--color-neutral-200)",
    neutral300: "var(--color-neutral-300)",
    neutral400: "var(--color-neutral-400)",
    neutral500: "var(--color-neutral-500)",
    neutral600: "var(--color-neutral-600)",
    neutral700: "var(--color-neutral-700)",
    neutral800: "var(--color-neutral-800)",
    neutral900: "var(--color-neutral-900)",
    neutral1000: "var(--color-neutral-1000)",
    neutral1100: "var(--color-neutral-1100)",
    neutral1200: "var(--color-neutral-1200)",
    neutral1300: "var(--color-neutral-1300)",
    neutral1400: "var(--color-neutral-1400)",
    neutral1500: "var(--color-neutral-1500)",
    neutral1600: "var(--color-neutral-1600)",
    green100: "var(--color-green-100)",
    green200: "var(--color-green-200)",
    green300: "var(--color-green-300)",
    green400: "var(--color-green-400)",
    green500: "var(--color-green-500)",
    green600: "var(--color-green-600)",
    green700: "var(--color-green-700)",
    green800: "var(--color-green-800)",
    green900: "var(--color-green-900)",
    yellow100: "var(--color-yellow-100)",
    yellow200: "var(--color-yellow-200)",
    yellow300: "var(--color-yellow-300)",
    yellow400: "var(--color-yellow-400)",
    yellow500: "var(--color-yellow-500)",
    yellow600: "var(--color-yellow-600)",
    yellow700: "var(--color-yellow-700)",
    yellow800: "var(--color-yellow-800)",
    yellow900: "var(--color-yellow-900)",
    red100: "var(--color-red-100)",
    red200: "var(--color-red-200)",
    red300: "var(--color-red-300)",
    red400: "var(--color-red-400)",
    red500: "var(--color-red-500)",
    red600: "var(--color-red-600)",
    red700: "var(--color-red-700)",
    red800: "var(--color-red-800)",
    red900: "var(--color-red-900)",
    blue100: "var(--color-blue-100)",
    blue200: "var(--color-blue-200)",
    blue300: "var(--color-blue-300)",
    blue400: "var(--color-blue-400)",
    blue500: "var(--color-blue-500)",
    blue600: "var(--color-blue-600)",
    blue700: "var(--color-blue-700)",
    blue800: "var(--color-blue-800)",
    blue900: "var(--color-blue-900)",
    transportTeal100: "var(--color-transport-teal-100)",
    transportTeal200: "var(--color-transport-teal-200)",
    transportTeal300: "var(--color-transport-teal-300)",
    transportTeal400: "var(--color-transport-teal-400)",
    transportTeal500: "var(--color-transport-teal-500)",
    transportTeal600: "var(--color-transport-teal-600)",
    transportTeal700: "var(--color-transport-teal-700)",
    transportTeal800: "var(--color-transport-teal-800)",
    transportTeal900: "var(--color-transport-teal-900)",
    transportOrange100: "var(--color-transport-orange-100)",
    transportOrange200: "var(--color-transport-orange-200)",
    transportOrange300: "var(--color-transport-orange-300)",
    transportOrange400: "var(--color-transport-orange-400)",
    transportOrange500: "var(--color-transport-orange-500)",
    transportOrange600: "var(--color-transport-orange-600)",
    transportOrange700: "var(--color-transport-orange-700)",
    transportOrange800: "var(--color-transport-orange-800)",
    transportOrange900: "var(--color-transport-orange-900)",
    transportBlue100: "var(--color-transport-blue-100)",
    transportBlue200: "var(--color-transport-blue-200)",
    transportBlue300: "var(--color-transport-blue-300)",
    transportBlue400: "var(--color-transport-blue-400)",
    transportBlue500: "var(--color-transport-blue-500)",
    transportBlue600: "var(--color-transport-blue-600)",
    transportBlue700: "var(--color-transport-blue-700)",
    transportBlue800: "var(--color-transport-blue-800)",
    transportBlue900: "var(--color-transport-blue-900)",
    transportRed100: "var(--color-transport-red-100)",
    transportRed200: "var(--color-transport-red-200)",
    transportRed300: "var(--color-transport-red-300)",
    transportRed400: "var(--color-transport-red-400)",
    transportRed500: "var(--color-transport-red-500)",
    transportRed600: "var(--color-transport-red-600)",
    transportRed700: "var(--color-transport-red-700)",
    transportRed800: "var(--color-transport-red-800)",
    transportRed900: "var(--color-transport-red-900)",
    transportGreen100: "var(--color-transport-green-100)",
    transportGreen200: "var(--color-transport-green-200)",
    transportGreen300: "var(--color-transport-green-300)",
    transportGreen400: "var(--color-transport-green-400)",
    transportGreen500: "var(--color-transport-green-500)",
    transportGreen600: "var(--color-transport-green-600)",
    transportGreen700: "var(--color-transport-green-700)",
    transportGreen800: "var(--color-transport-green-800)",
    transportGreen900: "var(--color-transport-green-900)",
    transportPurple100: "var(--color-transport-purple-100)",
    transportPurple200: "var(--color-transport-purple-200)",
    transportPurple300: "var(--color-transport-purple-300)",
    transportPurple400: "var(--color-transport-purple-400)",
    transportPurple500: "var(--color-transport-purple-500)",
    transportPurple600: "var(--color-transport-purple-600)",
    transportPurple700: "var(--color-transport-purple-700)",
    transportPurple800: "var(--color-transport-purple-800)",
    transportPurple900: "var(--color-transport-purple-900)",
    transportYellow100: "var(--color-transport-yellow-100)",
    transportYellow200: "var(--color-transport-yellow-200)",
    transportYellow300: "var(--color-transport-yellow-300)",
    transportYellow400: "var(--color-transport-yellow-400)",
    transportYellow500: "var(--color-transport-yellow-500)",
    transportYellow600: "var(--color-transport-yellow-600)",
    transportYellow700: "var(--color-transport-yellow-700)",
    transportYellow800: "var(--color-transport-yellow-800)",
    transportYellow900: "var(--color-transport-yellow-900)",
    transportGrey100: "var(--color-transport-grey-100)",
    transportGrey200: "var(--color-transport-grey-200)",
    transportGrey300: "var(--color-transport-grey-300)",
    transportGrey400: "var(--color-transport-grey-400)",
    transportGrey500: "var(--color-transport-grey-500)",
    transportGrey600: "var(--color-transport-grey-600)",
    transportGrey700: "var(--color-transport-grey-700)",
    transportGrey800: "var(--color-transport-grey-800)",
    transportGrey900: "var(--color-transport-grey-900)",
    transportBlack100: "var(--color-transport-black-100)",
    transportBlack200: "var(--color-transport-black-200)",
    transportBlack300: "var(--color-transport-black-300)",
    transportBlack400: "var(--color-transport-black-400)",
    transportBlack500: "var(--color-transport-black-500)",
    transportBlack600: "var(--color-transport-black-600)",
    transportBlack700: "var(--color-transport-black-700)",
    transportBlack800: "var(--color-transport-black-800)",
    transportBlack900: "var(--color-transport-black-900)",
    accommodationBlue100: "var(--color-accommodation-blue-100)",
    accommodationBlue200: "var(--color-accommodation-blue-200)",
    accommodationBlue300: "var(--color-accommodation-blue-300)",
    accommodationBlue400: "var(--color-accommodation-blue-400)",
    accommodationBlue500: "var(--color-accommodation-blue-500)",
    accommodationBlue600: "var(--color-accommodation-blue-600)",
    accommodationBlue700: "var(--color-accommodation-blue-700)",
    accommodationBlue800: "var(--color-accommodation-blue-800)",
    accommodationBlue900: "var(--color-accommodation-blue-900)",
    pointOfInterestAmusement100: "var(--color-point-of-interest-amusement-100)",
    pointOfInterestLandmark100: "var(--color-point-of-interest-landmark-100)",
    pointOfInterestAquarium100: "var(--color-point-of-interest-aquarium-100)",
    pointOfInterestGardenpark100:
      "var(--color-point-of-interest-gardenpark-100)",
    pointOfInterestMuseum100: "var(--color-point-of-interest-museum-100)",
    pointOfInterestArchitecture100:
      "var(--color-point-of-interest-architecture-100)",
    pointOfInterestCasino100: "var(--color-point-of-interest-casino-100)",
    pointOfInterestCastledfort100:
      "var(--color-point-of-interest-castledfort-100)",
    pointOfInterestChurch100: "var(--color-point-of-interest-church-100)",
    pointOfInterestFountain100: "var(--color-point-of-interest-fountain-100)",
    pointOfInterestMountain100: "var(--color-point-of-interest-mountain-100)",
    pointOfInterestSculpture100: "var(--color-point-of-interest-sculpture-100)",
    pointOfInterestSkiing100: "var(--color-point-of-interest-skiing-100)",
    pointOfInterestTheatre100: "var(--color-point-of-interest-theatre-100)",
    pointOfInterestWaterfall100: "var(--color-point-of-interest-waterfall-100)",
    pointOfInterestZoo100: "var(--color-point-of-interest-zoo-100)",
    neutralAlpha100: "var(--color-neutral-alpha-100)",
    neutralAlpha200: "var(--color-neutral-alpha-200)",
    neutralAlpha300: "var(--color-neutral-alpha-300)",
    neutralAlpha400: "var(--color-neutral-alpha-400)",
    neutralAlpha500: "var(--color-neutral-alpha-500)",
    neutralAlpha600: "var(--color-neutral-alpha-600)",
    neutralAlpha700: "var(--color-neutral-alpha-700)",
    neutralAlpha800: "var(--color-neutral-alpha-800)",
    neutralAlpha900: "var(--color-neutral-alpha-900)",
    neutralAlpha1000: "var(--color-neutral-alpha-1000)",
    neutralAlpha1100: "var(--color-neutral-alpha-1100)",
    neutralAlpha1200: "var(--color-neutral-alpha-1200)",
    neutralAlpha1300: "var(--color-neutral-alpha-1300)",
    neutralAlpha1400: "var(--color-neutral-alpha-1400)",
    neutralAlpha1500: "var(--color-neutral-alpha-1500)",
    neutralAlpha1600: "var(--color-neutral-alpha-1600)",
  },
} as const;

/**
 * @deprecated Use tokens instead of primitives.
 */
export const primitive = {
  product_500: "#c90070",
  neutral_100: "#ffffff",
  neutral_300: "#fafafa",
  neutral_400: "#f7f7f7",
  neutral_500: "#f3f3f3",
  neutral_700: "#ebebeb",
  neutral_800: "#e3e3e3",
  neutral_900: "#d4d4d4",
  neutral_1100: "#b5b5b5",
  neutral_1500: "#303030",
  neutral_1600: "#1a1a1a",
  neutral_alpha_700: "rgba(0, 0, 0, 0.13)",
  neutral_alpha_1200: "rgba(0, 0, 0, 0.45)",
  blue_500: "#3269d9",
} as const;

export default color;
